export default "__VITE_ASSET__Bcc8BTww__"